<footer class="modern-footer">
  <div class="footer-container">
    <button class="legal-toggle" (click)="toggleLegalContent()" type="button">
      <i class="fas fa-info-circle"></i>
      Legal Information
      <i class="fas fa-chevron-down" [class.rotated]="isLegalContentVisible"></i>
    </button>

    <div class="legal-content" [class.visible]="isLegalContentVisible">
      <div [innerHtml]="footerHtml" class="legal-text"></div>
    </div>
  </div>
</footer>
